import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell, BellOff, Car, Bus, AlertCircle, CheckCircle2 } from "lucide-react";

const ICONS = {
  ride_assigned: Car,
  driver_en_route: Car,
  driver_arrived: CheckCircle2,
  trip_completed: CheckCircle2,
  bus_booked: Bus,
  new_trip: Car,
  default: Bell,
};

export default function Notifications() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/notifications").then((r) => setItems(r.data || []));
  }, []);

  async function markAll() {
    await api.post("/notifications/read-all");
    setItems(items.map((n) => ({ ...n, is_read: true })));
  }

  async function mark(id) {
    await api.post(`/notifications/${id}/read`);
    setItems(items.map((n) => (n.id === id ? { ...n, is_read: true } : n)));
  }

  const unread = items.filter((i) => !i.is_read).length;

  return (
    <div className="min-h-screen bg-white">
      <div className="px-5 pt-safe pt-8 pb-3 flex items-end justify-between">
        <div>
          <p className="text-[11px] uppercase tracking-widest text-slate-400 font-bold">Inbox</p>
          <h1 className="font-display font-bold text-3xl text-slate-900">Alerts</h1>
        </div>
        {unread > 0 && (
          <button data-testid="mark-all-read" onClick={markAll} className="text-xs font-bold text-primary uppercase tracking-wide">
            Mark all read · {unread}
          </button>
        )}
      </div>

      <div className="px-5 mt-3 pb-32 space-y-2">
        {items.length === 0 ? (
          <div className="text-center py-16 text-slate-400" data-testid="notifications-empty">
            <BellOff size={48} className="mx-auto opacity-40" />
            <p className="mt-3 font-semibold text-slate-500">All caught up</p>
          </div>
        ) : (
          items.map((n) => {
            const Icon = ICONS[n.type] || ICONS.default;
            return (
              <button
                key={n.id}
                data-testid={`notification-${n.id}`}
                onClick={() => mark(n.id)}
                className={`w-full text-left flex items-start gap-3 p-4 rounded-2xl border transition-all ${
                  n.is_read ? "bg-white border-slate-200" : "bg-primary-50/40 border-primary-200"
                }`}
              >
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${n.is_read ? "bg-slate-100 text-slate-500" : "bg-primary text-white"}`}>
                  <Icon size={18} />
                </div>
                <div className="flex-1">
                  <p className="font-display font-bold text-slate-900 text-sm">{n.title}</p>
                  <p className="text-xs text-slate-600 mt-0.5">{n.body}</p>
                  <p className="text-[10px] text-slate-400 mt-1 font-mono">
                    {new Date(n.created_at).toLocaleString("en-AE", { dateStyle: "short", timeStyle: "short" })}
                  </p>
                </div>
                {!n.is_read && <span className="w-2 h-2 rounded-full bg-primary mt-2" />}
              </button>
            );
          })
        )}
      </div>
    </div>
  );
}
